<ng-container *transloco="let t; read: 'report-date-range-picker'">
  <div [style.visibility]="isInit ? 'visible' : 'hidden'">
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" [formGroup]="dateForm">
      <mat-form-field>
        <mat-label>{{ t('From') }}</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="from" [placeholder]="t('From')" readonly="true" />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker
          #fromPicker
          startView="year"
          (monthSelected)="monthSelectedFrom($event, fromPicker)"
          [calendarHeaderComponent]="headerComponent"
        ></mat-datepicker>
      </mat-form-field>
      <div>-</div>
      <mat-form-field>
        <mat-label>{{ t('To') }}</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="to" [placeholder]="t('To')" readonly="true" />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker
          #toPicker
          startView="year"
          (monthSelected)="monthSelectedTo($event, toPicker)"
          [calendarHeaderComponent]="headerComponent"
        ></mat-datepicker>
      </mat-form-field>
      <mat-spinner *ngIf="isReloading" diameter="30"></mat-spinner>
    </div>
    <mat-error *ngIf="errorDateRange">{{ t('Range error: Start date should be before end date!') }}</mat-error>
  </div>
</ng-container>
